import React from 'react';
import Loadable from 'react-loadable';

const Loader = props => {
  // react-loadable delivers chunk-load failures here instead of throwing
  if (props.error) {
    console.error('[loadable] chunk failed to load:', props.error);
  }
  return <div className="text-center" />;
};

export default loader =>
  Loadable({
    // Native ESM namespaces (Vite) lack the __esModule flag react-loadable's
    // resolver relies on, so unwrap the default export ourselves
    loader: () => loader().then(m => (m && m.default ? m.default : m)),
    loading: Loader,
  });
